import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService, GlobalMessageService, WindowRef, GlobalMessageType, RoutingService, TranslationService, AuthConfigService, AuthStorageService, UrlPipe } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { from } from 'rxjs';
import { withLatestFrom, tap, pairwise } from 'rxjs/operators';
import{CustomInventoryLoginService} from 'src/app/modules/custom-login/custom-inventory-login/custom-inventory-login.service';
import { InventoryBreadcrumbComponent } from '../../../shared/components/inventory-breadcrumb/inventory-breadcrumb.component';
@Component({
    selector: 'app-custom-inventory-login',
    templateUrl: './custom-inventory-login.component.html',
    styleUrls: ['./custom-inventory-login.component.scss'],
    imports: [RouterLink, InventoryBreadcrumbComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, UrlPipe]
})
export class CustomInventoryLoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  notValidCreds = false;
  loginData: any;
  title: any;
  navigationData: any;
  isDisabled = false;
  constructor(
    protected auth: AuthService,
    private customInventoryLoginService: CustomInventoryLoginService,
    protected globalMessageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected winRef: WindowRef,
    private router: Router,
    private translation: TranslationService,
    private routingService: RoutingService,
    private cd: ChangeDetectorRef,
    private authConfigService: AuthConfigService,
    private authStorageService: AuthStorageService
  ) { }

  ngOnInit(): void {
    const routeState = this.winRef.nativeWindow?.history?.state;
     this.translation.translate('breadcrumb.inventoryLogin.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.inventoryLogin.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    const prefilledEmail = routeState?.['newUid'];
    this.loginForm = this.fb.group({
      userId: [
        prefilledEmail?.length ? prefilledEmail : '',
        [Validators.required],
      ],
      password: ['', Validators.required],
    });
  }
  submitForm(): void {
    if (this.loginForm.valid) {
      // this.loginUser();
      this.isDisabled = true;
      this.checkLoginCreds();
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  protected checkLoginCreds(): any {
    const { userId, password } = this.loginForm.controls;
    this.customInventoryLoginService.getUserPwd(password.value);
    this.customInventoryLoginService.checkUserCredentials(userId.value.toLowerCase(), password.value)
      .subscribe(data => {
        this.isDisabled = false;
        this.notValidCreds = false;
        let t = new Date();
        t.setSeconds(t.getSeconds()+data.expires_in);
        this.loginData = {...data,expiredDate:t};
        sessionStorage.setItem("loginData",JSON.stringify(this.loginData));
        this.router.navigate(['inventory/inventorymanagement']);
      },
      err=>{
        
          this.notValidCreds = false;
          this.notValidCreds = true;
          this.isDisabled = false;
          this.cd.detectChanges();
          //console.log(err.error.errors[0].message)
          this.globalMessageService.add(err.error.errors[0].message, GlobalMessageType.MSG_TYPE_ERROR);
        
      }

      
      );

  }

  protected loginUserCheck(): void {
    const { userId, password } = this.loginForm.controls;
    this.customInventoryLoginService.checkUserCredentials(userId.value.toLowerCase(), password.value)
      .pipe(
        withLatestFrom(this.auth.isUserLoggedIn()),
        tap(([_, isLoggedIn]) => {
          if (isLoggedIn) {
            this.routingService.go({
              cxRoute: 'inventory/inventorymanagement',
            });
            // We want to remove error messages on successful login (primary the bad username/password combination)
            // this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      )
      .subscribe();
  }

  protected loginUser(): void {
    const { userId, password } = this.loginForm.controls;
    from(
      this.auth.loginWithCredentials(
        userId.value.toLowerCase(), // backend accepts lowercase emails only
        password.value
      )
    )
      .pipe(
        withLatestFrom(this.auth.isUserLoggedIn()),
        tap(([_, isLoggedIn]) => {
          if (isLoggedIn) {
            this.routingService.go({
              cxRoute: 'inventory/inventorymanagement',
            });
            // We want to remove error messages on successful login (primary the bad username/password combination)
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      )
      .subscribe();
  }

  //SSO Sign in
  ssoSignIn() {
    console.log("Base URL", this.authConfigService.getBaseUrl());
    console.log("client ID", this.authConfigService.getClientId());
    console.log("Client secret", this.authConfigService.getClientSecret());
    console.log("ID Token", this.authStorageService.getItem("id_token"));
    console.log(this.auth.isUserLoggedIn());
    this.auth.loginWithRedirect();
  }

  }
